import Item, { type ChipItemProps } from "./Item"
import List, { type ChipListProps } from "./List"

export default { List, Item }
export type { ChipListProps, ChipItemProps }
